/* KADIMAN RETAIL 2026 — interacciones */
(function () {
  'use strict';

  function initSlider(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var track = root.querySelector('[data-track]');
    if (!track) return;
    var slides = track.children;
    var n = slides.length;
    if (n < 2) return;
    var i = 0, timer = null;
    var dotsWrap = root.querySelector('[data-dots]');
    var dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var d = 0; d < n; d++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Ir al banner ' + (d + 1));
        (function (k) { b.addEventListener('click', function () { go(k); restart(); }); })(d);
        dotsWrap.appendChild(b);
        dots.push(b);
      }
    }
    function go(k) {
      i = (k + n) % n;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      for (var s = 0; s < n; s++) slides[s].setAttribute('aria-hidden', s === i ? 'false' : 'true');
      dots.forEach(function (el, idx) { el.classList.toggle('is-active', idx === i); });
    }
    var secs = parseInt(root.dataset.autoplay || '0', 10);
    function restart() {
      if (timer) clearInterval(timer);
      if (secs > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = setInterval(function () { go(i + 1); }, secs * 1000);
      }
    }
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(i + 1); restart(); });
    root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); restart(); }
      x0 = null;
    });
    go(0);
    restart();
  }

  function initRotator(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var items = root.children;
    if (items.length < 2) return;
    var k = 0;
    setInterval(function () {
      items[k].classList.remove('is-active');
      k = (k + 1) % items.length;
      items[k].classList.add('is-active');
    }, 4500);
  }

  function initMega() {
    var header = document.querySelector('[data-header]');
    if (!header || header.dataset.ready) return;
    header.dataset.ready = '1';
    var bar = header.querySelector('.kr-header__bar');
    var triggers = header.querySelectorAll('[data-mega]');
    var closeTimer = null;
    var current = null;

    function open(id) {
      clearTimeout(closeTimer);
      if (current === id) return;
      var top = bar.getBoundingClientRect().bottom;
      header.querySelectorAll('[data-panel]').forEach(function (p) {
        var on = p.id === id;
        p.classList.toggle('is-active', on);
        if (on) p.style.paddingTop = (top + 24) + 'px';
      });
      triggers.forEach(function (t) {
        var on = t.dataset.mega === id;
        t.classList.toggle('is-current', on);
        t.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      header.classList.add('is-open');
      current = id;
    }
    function close() {
      header.querySelectorAll('[data-panel]').forEach(function (p) { p.classList.remove('is-active'); });
      triggers.forEach(function (t) { t.classList.remove('is-current'); t.setAttribute('aria-expanded', 'false'); });
      header.classList.remove('is-open');
      current = null;
    }
    function scheduleClose() { clearTimeout(closeTimer); closeTimer = setTimeout(close, 280); }

    var canHover = window.matchMedia('(hover: hover)').matches;
    triggers.forEach(function (t) {
      if (canHover) t.addEventListener('mouseenter', function () { open(t.dataset.mega); });
      t.addEventListener('click', function () { current === t.dataset.mega ? close() : open(t.dataset.mega); });
    });
    if (canHover) {
      header.addEventListener('mouseleave', scheduleClose);
      header.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      header.querySelectorAll('.kr-navlink:not([data-mega])').forEach(function (a) {
        a.addEventListener('mouseenter', scheduleClose);
      });
    }
    var x = header.querySelector('[data-mega-close]');
    if (x) x.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.addEventListener('scroll', function () { if (current && window.scrollY > 400) close(); }, { passive: true });
  }

  function openDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawers() {
    document.querySelectorAll('.kr-drawer.is-open').forEach(function (el) {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    });
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]')) { closeDrawers(); return; }

    var sw = e.target.closest('.kr-swatch[data-img]');
    if (sw) {
      var card = sw.closest('.kr-card');
      var img = card && card.querySelector('.kr-card__img1');
      if (img) {
        img.removeAttribute('srcset');
        img.src = sw.dataset.img;
      }
      card.querySelectorAll('.kr-swatch').forEach(function (s) { s.classList.remove('is-active'); });
      sw.classList.add('is-active');
      if (sw.dataset.url) card.querySelectorAll('a.kr-card__media, a.kr-card__title').forEach(function (a) { a.href = sw.dataset.url; });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-sort]')) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  function init() {
    document.querySelectorAll('[data-slider]').forEach(initSlider);
    document.querySelectorAll('[data-rotator]').forEach(initRotator);
    initMega();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
